"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsBadge = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
var NotificationsBadge = function (boxProps) {
    var _a = (0, useHeaderProps_1.useHeaderProps)(), totalUnreadNotifications = _a.totalUnreadNotifications, _js = _a._js;
    if (!totalUnreadNotifications) {
        return null;
    }
    var countDisplay = totalUnreadNotifications < 100 ? totalUnreadNotifications : '99+';
    var fontSize = totalUnreadNotifications < 100 ? '0.8rem' : '0.7rem';
    var paddingX = totalUnreadNotifications < 100 ? 1.5 : 1;
    return (React.createElement(react_1.Box, __assign({ as: "span", position: "absolute", bg: "red.500", borderRadius: 20, h: "15px", lineHeight: "15px", py: 0, px: paddingX, fontSize: fontSize, color: "white", title: _js('Total unread notifications') }, boxProps), countDisplay));
};
exports.NotificationsBadge = NotificationsBadge;
